module["exports"] = [
  "Снаб",
  "Торг",
  "Пром",
  "Трейд",
  "Сбыт"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/company/suffix.js
// module id = 1187
// module chunks = 0